import React from "react";
import HomeSessionsComp from "../../../../../../Components/BookingsComp";
import { useState, useEffect } from "react";
import { createBookingSession, getAllFaq } from "../../Constants/api";
import { getAllSupportAdvisorApi } from "../../../Courses/Constants/api";
import { EditorState } from "draft-js";
import { creatingStates } from "../../../Blogs/Constants";
import { uploadFile } from "../../../Blogs/others/Uploads/upload.Helper";
import UploadBlogsStatus from "../../../../../../Components/UploadBlogsStatus";
import SweetAlert from "react-bootstrap-sweetalert";
const CreateSessions = () => {
  const [formData, setFormData] = useState({
    title: "",
    image: "",
    supportAdvisor: "",
    Faqs: [],
  });
  const [advisor, setAdvisor] = useState([]);
  const [adName, setAdName] = useState([]);
  const [learnTitle, setLearnTitle] = useState("");
  const [learnImg, setLearnImg] = useState("");
  const [learnTitleTwo, setLearnTitleTwo] = useState("");
  const [learnImgTwo, setLearnImgTwo] = useState("");
  const [learnTitleThree, setLearnTitleThree] = useState("");
  const [learnImgThree, setLearnImgThree] = useState("");
  const [faq, setFaq] = useState("");
  const [faqData, setFaqData] = useState("");
  const [description, setDescription] = useState(EditorState.createEmpty());
  const [showUnPublishAlert, setShowUnPublishAlert] = useState(false);
  const [showUnPublishConfirm, setShowUnPublishConfirm] = useState(false);
  const [creating, setCreating] = useState({
    isCreating: false,
    creatingStage: creatingStates.UPLOADING_IMAGE,
  });
  const [content, setContent] = useState(null);
  const [headerImg, setHeaderImg] = useState("");
  const [error, setError] = useState({
    isError: false,
    errorMessage: "",
    errorType: "warning",
  });

  const { isCreating, creatingStage } = creating;
  const [thumbnailuploadPercentage, setThumbnailUploadPercentage] = useState(0);
  const [contentUploadPercentage, setContentUploadPercentage] = useState(0);
  const { title, image, supportAdvisor } = formData;

  const handleChangeSession = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const getAllAdvisorData = async () => {
    const { data } = await getAllSupportAdvisorApi();
    console.log(data.data);
    setAdvisor(data?.data);
  };

  const getAllFaqData = async () => {
    const { data } = await getAllFaq();
    setFaqData(data?.faqs);
    console.log(data?.faqs, "asdfghjkl");
  };
  useEffect(() => {
    getAllAdvisorData();
    getAllFaqData();
  }, []);
  const formatMultiSelectData = (data) => {
    console.log(data, "asdfghjkl;sdfghjk");
    let formatedData;
    if (Array.isArray(data)) {
      formatedData = data && data.length > 0 && data?.map(({ value }) => value);
    } else if (data?.value) {
      formatedData = data?.value;
    } else {
      formatedData = [];
    }
    return formatedData;
  };
  const handleCreateSession = async () => {
    console.log("enter");
    try {
      console.log("try enter");
      if (!headerImg)
        return setError({
          isError: true,
          errorMessage: "Please select a cover image",
          errorType: "warning",
        });

      setCreating({
        isCreating: true,
        creatingStage: creatingStates.UPLOADING_IMAGE,
      });

      const headerImgUrl = await uploadFile(
        headerImg,
        "COURSES-IMAGE",
        setThumbnailUploadPercentage,
        20
      );
      setCreating({
        isCreating: true,
        creatingStage: creatingStates.UPLOADING_MUSIC,
      });

      setCreating({
        isCreating: true,
        creatingStage: creatingStates.UPLOADING_IMAGE,
      });
      if (!learnImg)
        return setError({
          isError: true,
          errorMessage: "Please select a cover image",
          errorType: "warning",
        });

      setCreating({
        isCreating: true,
        creatingStage: creatingStates.UPLOADING_IMAGE,
      });

      const learnImgUrl = await uploadFile(
        learnImg,
        "COURSES-IMAGE",
        setThumbnailUploadPercentage,
        30
      );
      setCreating({
        isCreating: true,
        creatingStage: creatingStates.UPLOADING_MUSIC,
      });

      setCreating({
        isCreating: true,
        creatingStage: creatingStates.UPLOADING_IMAGE,
      });

      if (!learnImgTwo)
        return setError({
          isError: true,
          errorMessage: "Please select a cover image",
          errorType: "warning",
        });

      setCreating({
        isCreating: true,
        creatingStage: creatingStates.UPLOADING_IMAGE,
      });

      const learnImgTwoUrl = await uploadFile(
        learnImgTwo,
        "COURSES-IMAGE",
        setThumbnailUploadPercentage,
        40
      );
      setCreating({
        isCreating: true,
        creatingStage: creatingStates.UPLOADING_MUSIC,
      });

      setCreating({
        isCreating: true,
        creatingStage: creatingStates.UPLOADING_IMAGE,
      });

      if (!learnImgThree)
        return setError({
          isError: true,
          errorMessage: "Please select a cover image",
          errorType: "warning",
        });

      setCreating({
        isCreating: true,
        creatingStage: creatingStates.UPLOADING_IMAGE,
      });

      const learnImgThreeUrl = await uploadFile(
        learnImgThree,
        "COURSES-IMAGE",
        setThumbnailUploadPercentage,
        90
      );
      setCreating({
        isCreating: true,
        creatingStage: creatingStates.UPLOADING_MUSIC,
      });

      setCreating({
        isCreating: true,
        creatingStage: creatingStates.UPLOADING_IMAGE,
      });

      await createBookingSession({
        title: formData.title,
        description: content,
        image: headerImgUrl,
        supportAdvisorId: formatMultiSelectData(adName),
        learning: [
          {
            image: learnImgUrl,
            title: learnTitle,
          },
          {
            image: learnImgTwoUrl,
            title: learnTitleTwo,
          },
          {
            image: learnImgThreeUrl,
            title: learnTitleThree,
          },
        ],
        faqId: formatMultiSelectData(faq),
      });

      setCreating({
        isCreating: true,
        creatingStage: creatingStates.UPLOAD_COMPLETE,
      });
    } catch (error) {
      console.log(error, error);
      setCreating({
        isCreating: false,
        creatingStage: creatingStates.UPLOADING_IMAGE,
      });
      setThumbnailUploadPercentage(0);
      setContentUploadPercentage(0);
      setError({
        isError: true,
        errorMessage: "Unable to create Image please try again later",
        errorType: "danger",
      });
    }
  };

  const reset = () => {
    setLearnImg(null);
    setLearnImgTwo(null);
    setLearnImgThree(null);
    setHeaderImg(null);
    setLearnTitle("");
    setLearnTitleTwo("");
    setLearnTitleThree("");
    setDescription(EditorState.createEmpty());
    setAdName([]);
    setFaq("");
    setError({
      isError: false,
      errorMessage: "",
      errorType: "warning",
    });
    setFormData({
      title: "",
      image: "",
      supportAdvisor: "",
      Faqs: [],
    });
    setCreating({
      isCreating: false,
      creatingStage: creatingStates.UPLOADING_IMAGE,
    });
  };

  return (
    <>
      {isCreating ? (
        <UploadBlogsStatus
          currentStep={creatingStage}
          thumbnailUploadPercentage={thumbnailuploadPercentage}
          contentUploadPercentage={contentUploadPercentage}
          reset={reset}
          fileName="booking-session"
        />
      ) : (
        <HomeSessionsComp
          pageHeading={"CreateHomeSession"}
          handleChangeSession={handleChangeSession}
          headerImg={headerImg}
          setHeaderImg={setHeaderImg}
          faq={faq}
          faqData={faqData}
          setFaqData={setFaqData}
          setFaq={setFaq}
          setAdName={setAdName}
          adName={adName}
          setLearnImgThree={setLearnImgThree}
          setLearnTitleThree={setLearnTitleThree}
          setLearnImgTwo={setLearnImgTwo}
          setLearnTitleTwo={setLearnTitleTwo}
          learnImgThree={learnImgThree}
          learnTitleThree={learnTitleThree}
          learnImgTwo={learnImgTwo}
          learnTitleTwo={learnTitleTwo}
          setLearnImg={setLearnImg}
          learnImg={learnImg}
          setContent={setContent}
          formData={formData}
          setFormData={setFormData}
          title={title}
          description={description}
          setDescription={setDescription}
          image={image}
          advisor={advisor}
          setAdvisor={setAdvisor}
          supportAdvisor={supportAdvisor}
          learnTitle={learnTitle}
          setLearnTitle={setLearnTitle}
          handleCreateSession={handleCreateSession}
        />
      )}
      {showUnPublishAlert ? (
        <SweetAlert
          title="Are you sure?"
          warning
          showCancel
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes,Create it!"
          reverseButtons={true}
          onConfirm={() => {
            handleCreateSession();
            setShowUnPublishAlert();
          }}
          onCancel={() => setShowUnPublishAlert()}
        ></SweetAlert>
      ) : null}

      {showUnPublishConfirm ? (
        <SweetAlert
          success
          title="Edited!"
          confirmBtnBsStyle="primary"
          onConfirm={() => {
            setShowUnPublishAlert();
            setShowUnPublishConfirm();
            history.push("/dashboard/booking-session/all");
          }}
        >
          Courses has been edited
        </SweetAlert>
      ) : null}
    </>
  );
};

export default CreateSessions;
